/* eslint-disable no-undef */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  FETCH_USER_BALANCES, FETCH_USER_INFO, GET_USER_LOGIN_HISTORY, UPDATE_USER_INFO,
} from '../actions/user/action_types';
import actions from '../actions/user';
import rf from '../../requests/RequestFactory';

// saga effect

function* fetchUserBalances() {
  try {
    const resp = yield call(() => rf.getRequest('UserRequest').fetchUserBalances());
    if (resp.error.code === 400) {
      window.localStorage.setItem('session', '');
      return;
    }
    yield put(actions.fetchUserBalancesSucceedAction(resp.data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.fetchUserBalancesFailedAction(err));
  }
}

function* updateUserInfo(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').updateUserInfo(params), action.params.data);
    if (resp.error.code === 400) {
      window.localStorage.setItem('session', '');
      return;
    }

    yield put(actions.updateUserInfoSucceedAction(resp.data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.updateUserInfoFailedAction(err));
  }
}

function* fetchUserInfo() {
  try {
    const resp = yield call(() => rf.getRequest('UserRequest').fetchUserInfo());
    if (resp.error.code === 400) {
      window.localStorage.setItem('session', '');
      return;
    }

    yield put(actions.fetchUserInfoSucceedAction(resp.data));
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
    yield put(actions.fetchUserInfoFailedAction(err));
  }
}

function* getUserLoginHistory(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').fetchUserLoginHistory(params), action.params.data);
    if (isFunction(action.callback)) {
      yield action.callback(resp.data, resp.total_count);
    }
  } catch (err) {
    console.error(err);
    console.log(err.message, '@: err.message');
  }
}

function* watchAllUsers() {
  yield takeLatest(FETCH_USER_BALANCES, fetchUserBalances);
  yield takeLatest(UPDATE_USER_INFO, updateUserInfo);
  yield takeLatest(FETCH_USER_INFO, fetchUserInfo);
  yield takeLatest(GET_USER_LOGIN_HISTORY, getUserLoginHistory);
}

export default function* rootSaga() {
  yield all([fork(watchAllUsers)]);
}
